
      document.getElementById('pageTitle').innerText = import.meta.env.VITE_APP_TITLE || 'Vue App';
    